/*
 * The page sequence that is common across most complaint workflows.
 * Include victim page by default.
 * Can be omitted by setting includeVictim to false.
 */
import { communicationContact } from '../choices'
import {
  activityBeginDatePage,
  activityEndDatePage,
  activityStillOccurringPage,
  complainantPage,
  fileUploadPage,
  narrativePage,
  permissionToDisclosePage,
  previouslyReportedDatePage,
  previouslyReportedPage,
  previouslyReportedToPage,
  PreviouslyReportedWarning,
  reportOnBehalfPage,
  subjectPage,
  warningPage,
  witnessCorroborationPage,
  victimPage,
  witnessPage
} from './index'

export const commonPageSequence = propOverrides => {
  const props = {
    includeVictim: true,
    subjectCount: 10,
    witnessCount: 10,
    ...propOverrides
  }
  const pageAfterSubject = props.includeVictim
    ? 'report_on_behalf_page'
    : 'witness_corroboration_page'

  const pageSequence = [
    activityBeginDatePage(),
    activityStillOccurringPage({
      gotoPageYes: 'previously_reported_page',
      gotoPageNo: 'activity_end_date_page'
    }),
    activityEndDatePage(),
    previouslyReportedPage({
      gotoPageYes: 'previously_reported_to_page',
      gotoPageNo: 'subject_page_0'
    }),
    {
      ...previouslyReportedToPage({ choices: communicationContact() }),
      action: {
        type: 'goto',
        pageId: values => {
          return values.communication_contact === 'hhs_oig'
            ? 'previously_reported_warning_page'
            : 'previously_reported_date_page'
        }
      }
    },
    warningPage({
      pageId: 'previously_reported_warning_page',
      warning: PreviouslyReportedWarning
    }),
    previouslyReportedDatePage(),
    subjectPage({ pageAfterSubject }),
    subjectPage({ index: 1, pageAfterSubject }),
    subjectPage({ index: 2, pageAfterSubject }),
    subjectPage({ index: 3, pageAfterSubject }),
    subjectPage({ index: 4, pageAfterSubject }),
    subjectPage({ index: 5, pageAfterSubject }),
    subjectPage({ index: 6, pageAfterSubject }),
    subjectPage({ index: 7, pageAfterSubject }),
    subjectPage({ index: 8, pageAfterSubject }),
    subjectPage({ index: 9, pageAfterSubject })
  ]

  // Optionally include the victim pages
  if (props.includeVictim)
    pageSequence.push(
      reportOnBehalfPage({
        gotoPageYes: 'victim_page',
        gotoPageNo: 'witness_corroboration_page'
      }),
      victimPage()
    )
  pageSequence.push(
    witnessCorroborationPage({
      gotoPageYes: 'witness_page_0',
      gotoPageNo: 'narrative_page'
    }),
    witnessPage({ maxIndex: 4 }),
    witnessPage({ index: 1, maxIndex: 4 }),
    witnessPage({ index: 2, maxIndex: 4 }),
    witnessPage({ index: 3, maxIndex: 4 }),
    witnessPage({ index: 4, maxIndex: 4 }),
    narrativePage(),
    fileUploadPage(),
    {
      ...permissionToDisclosePage(),
      action: {
        type: 'goto',
        pageId: values => {
          return values.perm_to_disclose == 'Anonymous'
            ? 'review_page'
            : 'complainant_page'
        }
      }
    },
    complainantPage()
  )
  return pageSequence
}
